import { render, staticRenderFns } from "./forestorytellingtour.vue?vue&type=template&id=5a1f6162&scoped=true&"
import script from "./forestorytellingtour.vue?vue&type=script&lang=js&"
export * from "./forestorytellingtour.vue?vue&type=script&lang=js&"
import style0 from "./forestorytellingtour.vue?vue&type=style&index=0&id=5a1f6162&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f6162",
  null
  
)

/* custom blocks */
import block0 from "./forestorytellingtour.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports